import React, { useState, useEffect } from "react";
import routes from '../api/index';
import Popup from 'reactjs-popup'
import '../styles/userpage.css'
import Navbar from './navbar'
import InProgress from './booklists/inprogress'
import Completed from './booklists/completed'
import UserPageButtonGroup from './userpageButtonGroup'
import '../styles/booklist.css'

const Userpage = (props) => {
    const [books, setBooks] = useState([])
    const [requestCount, setCount] = useState(0)

    // implement these functionalities later
    const [title, setTitle] = useState("")
    const [status, setStatus] = useState("In Progress")
    const [currentPage, setCurrentPage] = useState(-1)

    const [init, setInit] = useState(false)

    const [journalTitle, setJournalTitle] = useState("Untitled")
    const [journalBookTitle, setJournalBookTitle] = useState("General")
    const [journalContent, setJournalContent] = useState("")
    const [journals, setJournals] = useState([])
    // enable for client side protection
    // useEffect(() => {
    //     if(init) props.setToken();
    //     else setInit(true);
    //   }, [props.username]);

    useEffect(() => {
        routes.getUserbooks({ username: props.username })
            .then(res => res.data.books)
            .then(books => setBooks(books))
        routes.getJournals({ username: props.username })
            .then(res => res.data.journals)
            .then(journals => setJournals(journals))
    }, [requestCount]);

    function handleCreateBook() {
        const info = {
            user: props["username"],
            name: title,
            status: status,
            currentPage: parseInt(currentPage),
        }

        routes.createUserbook(info)
            .then(res => console.log(res.data))
            .then(() => setCount(requestCount + 1))
    }

    function handleUpdateBook(book, newTitle, newStatus, newCurrentPage) {
        const info = {
            id: book["_id"],
            user: props["username"],
            name: newTitle,
            status: newStatus,
            currentPage: parseInt(newCurrentPage),
        }

        routes.updateUserbook(info)
            .then(res => console.log(res.data))
            .then(() => setCount(requestCount + 1))
    }

    function updateStateToExistingBook(book) {
        setTitle(book["name"])
        setStatus(book["status"])
        setCurrentPage(book["currentPage"])
    }

    function handleAddJournal(bookTitle, journalTitle, journalContent, isPublic=true) {
        const info = {
            user: props.username,
            bookTitle: bookTitle,
            journalTitle: journalTitle,
            content: journalContent,
            public: isPublic,
        }

        routes.addJournal(info)
            .then(res => console.log(res.data))
            .then(() => setCount(requestCount + 1))

    }

    function filterJournals(bookTitle) {
        return (journals
            .filter(j => j.bookTitle === bookTitle).length > 0) ?
            journals
                .filter(j => j.bookTitle === bookTitle)
                .map(journal => <div> <span className="font-bold">{journal.journalTitle}</span> | <span className="italic">{journal.bookTitle}</span> | <span className="font-extralight text-sm">{journal.createdAt.substring(0, 10)}</span> <br /> {journal.content} <br /><br /> </div>)
            :
            <div className="font-thin text-sm">No journals for <span className="italic">{bookTitle}</span> have been added yet.</div>
    }

    const journalOptions = (filterTitle) => books.filter(book => book.name !== filterTitle).map(book => <option>{book.name}</option>)

    const displayJournals = (journals.length > 0) ?
        journals.map(journal => <div> <span className="font-bold">{journal.journalTitle}</span> | <span className="italic">{journal.bookTitle}</span> | <span className="font-extralight text-sm">{journal.createdAt.substring(0, 10)}</span> <br /> {journal.content} <br /><br /> </div>)
        :
        <div>No journals have been added yet, click on your book logs to add more.</div>

    return <div class="h-full pb-16">
        <div className="object-top"><Navbar loggedIn={true} setToken={props.setToken} /></div>
        <div className="grid font-mono justify-items-center">
            <UserPageButtonGroup
                updateStateToExistingBook={updateStateToExistingBook}
                setTitle={setTitle}
                setStatus={setStatus}
                setCurrentPage={setCurrentPage}
                displayJournals={displayJournals}
                handleCreateBook={handleCreateBook}
            />

            <div id="booklist-wrapper" className="w-full grid place-items-center">
                <div id="booklist" className="w-full sm:w-1/2">
                    <div className="w-full border-0 my-2 m-auto mb-20">
                        <h1 className="booklist-title in-progress-title">Books In Progress</h1>
                        {/* {inProgressBooks}   */}
                        <InProgress books={books}
                            updateStateToExistingBook={updateStateToExistingBook}
                            setJournalBookTitle={setJournalBookTitle}
                            setJournalTitle={setJournalTitle}
                            setJournalContent={setJournalContent}
                            setTitle={setTitle}
                            setStatus={setStatus}
                            setCurrentPage={setCurrentPage}
                            journalOptions={journalOptions}
                            handleAddJournal={handleAddJournal}
                            filterJournals={filterJournals}
                            handleUpdateBook={handleUpdateBook} />
                    </div>
                    <div className="border-0 m-auto">
                        <div className="booklist-title completed-title mb-3">Books Completed</div>
                            {/* {completedBooks}   */}
                            <Completed books={books}
                                updateStateToExistingBook={updateStateToExistingBook}
                                setJournalBookTitle={setJournalBookTitle}
                                setJournalTitle={setJournalTitle}
                                setJournalContent={setJournalContent}
                                setTitle={setTitle}
                                setStatus={setStatus}
                                setCurrentPage={setCurrentPage}
                                journalOptions={journalOptions}
                                handleAddJournal={handleAddJournal}
                                filterJournals={filterJournals}
                                handleUpdateBook={handleUpdateBook} />
                    </div>
                </div>
            </div>

        </div>
    </div>

}

export default Userpage